import { Gift, FileText, Layers, Infinity as InfinityIcon } from "lucide-react";
import { useI18n } from "../../i18n";

const ICONS = [FileText, Layers, Gift, InfinityIcon];

export default function Bonuses() {
  const { t, currency, fmtCcy } = useI18n();
  // Bonus values scale with currency
  const ratio = currency.code === "INR" ? 84 : currency.code === "EUR" ? 0.94 : 1;
  const VALUES = [49, 79, 29, 199].map((v) => Math.round(v * ratio));
  const total = VALUES.reduce((a, b) => a + b, 0);

  return (
    <section className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="chip">{t("bonus_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            <span className="text-[color:var(--gold)]">{fmtCcy(total)}</span>{" "}
            {t("bonus_h1_a")}
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-sm sm:text-base">
            {t("bonus_sub", { price: fmtCcy(currency.price) })}
          </p>
        </div>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {ICONS.map((Icon, i) => (
            <div key={i} className="panel p-5 sm:p-6 relative">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-xl grid place-items-center border border-[#23232a] bg-[rgba(231,180,59,.05)]">
                  <Icon className="w-4.5 h-4.5 text-[color:var(--gold)]" />
                </div>
                <div className="text-right">
                  <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)]">{t("bonus_worth")}</div>
                  <div className="font-display font-black text-[color:var(--gold)] text-sm sm:text-base">{fmtCcy(VALUES[i])}</div>
                </div>
              </div>
              <div className="font-display font-bold text-[15px] sm:text-[16px] mt-4">{t(`b${i + 1}_t`)}</div>
              <p className="text-[12px] sm:text-[13px] text-[color:var(--ink-dim)] mt-2 leading-relaxed">{t(`b${i + 1}_d`)}</p>
              <div className="mt-3 sm:mt-4 text-[10px] sm:text-[11px] font-mono uppercase tracking-widest text-[color:var(--green)]">{t("bonus_free")}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 sm:mt-10 panel p-5 sm:p-8 flex flex-wrap items-center gap-4 sm:gap-6 justify-between" style={{ borderColor: "rgba(231,180,59,.35)" }}>
          <div>
            <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-widest text-[color:var(--ink-mute)]">{t("bonus_total")}</div>
            <div className="font-display font-black text-2xl sm:text-3xl lg:text-4xl mt-1">
              <span className="line-through text-[color:var(--ink-mute)]">{fmtCcy(currency.mrp + total)}</span>
              <span className="text-[color:var(--gold)] glow-gold ml-3 sm:ml-4">{fmtCcy(currency.price)}</span>
            </div>
          </div>
          <div className="font-mono text-[11px] sm:text-xs uppercase tracking-widest text-[color:var(--green)] px-3 py-1.5 rounded-full border border-[color:var(--green)]/30 bg-[rgba(0,255,136,.05)]">
            {t("bonus_save", { amount: fmtCcy(currency.mrp + total - currency.price) })}
          </div>
        </div>
      </div>
    </section>
  );
}
